export default __webpack_public_path__ + "static/media/3.5c21bf76.png";